/*
 * Project: BookingEngine
 * Module: components/booking/rooms/Quota.js
 * vim:ft=javascript.jsx:
 * @flow
 */
import React from 'react';
import PropTypes from 'prop-types';
import { getRoomTypeLabel } from 'bookingform';

const getQuotaMessage = ({ quota, showValue, chain }, context) => {
  const roomType = getRoomTypeLabel(chain, context);
  const roomTypes = getRoomTypeLabel(chain, context, { plural: true });
  if (showValue) {
    return context.t('{quota} {roomTypes} left', { quota, roomTypes });
  }
  switch (quota) {
    case 0:
      return context.t('No availability');
    case 1:
      return context.t('Last available {roomType}!', { roomType });
    default:
      return context.t('Only {quota} {roomTypes} left', { quota, roomTypes });
  }
};

const Quota = (props, context) => {
  const { quota, showValue } = props;
  if (quota > 9 && !showValue) {
    return null;
  }

  const msg = getQuotaMessage(props, context);
  const isScarce = quota <= 1;
  return (
    <div className="room-quota">
      <div className={`room-quota__text text-capitalize${isScarce ? ' scarce' : ''}`}>
        {msg}
      </div>
    </div>
  );
};

Quota.propTypes = {
  showValue: PropTypes.bool,
  quota: PropTypes.number.isRequired,
  classes: PropTypes.string,
};

Quota.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Quota;
